import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { JobStatusGetResponse } from '../services/JobStatusService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/jobs/counts'), () => {
    return HttpResponse.json<JobStatusGetResponse>({
      tender: 100,
      request: 123,
      declined: 223,
    });
  }),
];
